// extracted by mini-css-extract-plugin
export default {"content":"dialogContent_content__7lXC-"};